import { internalFetch } from '../utils/fetchHelper';
import { IEntityLocation } from './assetServices';
import { IPagedCollection } from '@moko/utils';

export interface IRent {
  id: number;
  assetId: number;
  assetName?: string;
  renterId: number;
  renterName?: string;
  trackingDeviceId?: number;
  trackingDeviceName?: string;
  createdAt: string;
  agreedPrice: number;
  agreedPriceUnit: string;
  fromDate: Date;
  toDate: Date;
  statusId: number;
  status: string;
  description: string;
  code: string;
  otherInfo: string;
}

export interface IUpdateRentRequest {
  assetId: number;
  renterId: number;
  description: string;
  trackingDeviceId?: number;
  agreedPrice?: number;
  agreedPriceUnit?: string;
  fromDate?: Date;
  toDate?: Date;
  statusId?: number;
  status?: string;
  code: string;
  otherInfo: string;
}

export interface ICreateRentRequest {
  assetId: number;
  renterId: number;
  trackingDeviceId?: number;
  description?: string;
  agreedPrice?: number;
  agreedPriceUnit?: string;
  fromDate?: Date;
  toDate?: Date;
  statusId?: number;
  status?: string;
  code: string;
  otherInfo: string;
}

export interface ICreateRentResponse {
  rentId: number;
}

export const getRents = async (
  abortController: AbortController,
  pageSize: number,
  pageNo: number,
  renterId?: number,
  orderBy?: string,
  search?: string
): Promise<IPagedCollection<IRent>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/rents?pageSize=${pageSize}&pageNo=${pageNo}${
      renterId ? `&renterId=${renterId}` : ''
    }${orderBy ? `&orderBy=${orderBy}` : ''}${
      search ? `&search=${search}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};

export const getRent = async (
  abortController: AbortController,
  rentId?: number
): Promise<IRent> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/rentById?rentId=${rentId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};

export const editRent = async (
  abortController: AbortController,
  renterId: number,
  renter: IUpdateRentRequest
): Promise<number> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/rentById?rentId=${renterId}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'PUT',
    abortController,
    JSON.stringify(renter)
  );
};

export const createRent = async (
  abortController: AbortController,
  data: ICreateRentRequest
): Promise<ICreateRentResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/rent`,
    'POST',
    abortController,
    JSON.stringify(data)
  );
};

export const getRentLocations = async (
  abortController: AbortController,
  rentId: number,
  pageSize: number,
  pageNo: number
): Promise<IPagedCollection<IEntityLocation>> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/rentLocations?rentId=${rentId}&pageSize=${pageSize}&pageNo=${pageNo}&code=${
      import.meta.env.VITE_BACKEND_API_KEY
    }`,
    'GET',
    abortController
  );
};
